/**
 * Builds location string with priority: housingUnitName > facilityName > jurisdictionName
 * Shows only ONE location value based on priority (most specific first)
 * @param {Object} option - The option object containing location fields
 * @returns {string} - The location string, empty if no valid location found
 */
export const getLocationString = (option) => {
  if (option.housingUnitName && option.housingUnitName.trim() !== '') {
    return option.housingUnitName.trim();
  } else if (option.facilityName && option.facilityName.trim() !== '') {
    return option.facilityName.trim();
  } else if (option.jurisdictionName && option.jurisdictionName.trim() !== '') {
    return option.jurisdictionName.trim();
  }
  return '';
};

/**
 * Determines if location should be shown
 * @param {string} locationString - The location string to check
 * @returns {boolean} - True if location should be shown, false otherwise
 */
export const shouldShowLocation = (locationString) => {
  return typeof locationString === 'string' &&
    locationString !== '' && 
    !locationString.toLowerCase().includes('unknown location');
};

